import { render, staticRenderFns } from "./NavigationDrawlerRight.vue?vue&type=template&id=585d7f20&scoped=true&"
import script from "./NavigationDrawlerRight.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawlerRight.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDrawlerRight.vue?vue&type=style&index=0&id=585d7f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d7f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VDivider,VNavigationDrawer,VSelect,VTextField,VTextarea})
